import { render, staticRenderFns } from "./updatePTSL.vue?vue&type=template&id=2760dd00&lang=pug&"
import script from "./updatePTSL.vue?vue&type=script&lang=js&"
export * from "./updatePTSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports